import React, { useContext, useState, useEffect ,useRef} from 'react';
import forgeticon1 from '../../../Assets/Images/forgeticon2.png'
import { LangContext, FormNewPassword } from '../../../App'
import String from '../../../Assets/Localization/Local'
import { Modal, Col, Row, Button } from 'react-bootstrap'
import './ForgetPassword.css'
import { useForm } from "react-hook-form";
import { API_ENDPOINT } from '../../../AppConfig';
import axios from 'axios';
import NewPassword from './NewPassword'
import PinInput from "react-pin-input";
import Snackbar from '@material-ui/core/Snackbar';

function useInterval(callback, delay) {
  const savedCallback = useRef();


  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const ConfirmCode = (props) => {

  const { lang } = useContext(LangContext)
  const [data, setData] = useState();
  const [show, setShow] = useState(true);
  const [code, setCode] = useState()
  const [errormsg, setError] = useState(false)
  const [open, setOpen] = React.useState(false);
  const [error, setErrorSnakbar] = React.useState(null);
  const [count, setCount] = useState(0);
  const [variable, setVariable] = useState("00:00");
  const { openFormNewPass, ToggleForm_newPass } = useContext(FormNewPassword)

  String.setLanguage(lang);
  const { register, handleSubmit, errors, control, watch, setValue, getValues } = useForm({
    // validationSchema: props.validation
  });
  useEffect(() => {
    if (openFormNewPass === true) {
      setShow(false)
    }
  })
  const inputStyle = {
    textAlign: 'center',
    borderBottom: '2px solid #E3E3E3',
    fontSize: '22px',
    outline: 'none'
  }
  const handleShow = () => setShow(true);

  const onSubmit = (data) => {
    if (!code) {
      setError(true)
    } else if (code.length !== 5) {
      setError(true)
    }
    else {
      setData(props.phone)
      console.log('confirm code ==data-> ', data);
      let uri = `${API_ENDPOINT}/phoneConfirmationCode`;

      let submitData = {}
      submitData.phone = props.phone.phone
      submitData.code = code

      console.log('submitData code=> ', submitData, props)

      axios.put(uri, submitData, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        console.log('confirm code done==> ', response.data)
        ToggleForm_newPass()
      }).catch(error => {
        console.log('confirm code error==> ', error.response)
        setOpen(true);
        if (!error.response) {
          setErrorSnakbar("Network Error")
        }
        else if (error.response.status === 422) {
          for (let i = 0; i < error.response.data.errors.length; i++) {
            setErrorSnakbar(error.response.data.errors[i].msg)
          }
        }
        else {
          setErrorSnakbar(error.response.data.errors)
        }
      })
    }

  }
  const onChange = value => {
    setCode(value);
    setError(false)
  };
  const sendcode = () => {
    console.log('hello')

    let uri = `${API_ENDPOINT}/phoneForgetPassword`
    let data = {
      phone:props.phone.phone
    }

    console.log('SendCode uri==> ', uri, data)
    axios.post(uri, data, {
      headers: {
        'Content-Type': "application/json"
      }
    }).then(response => {
      console.log('SendCode uri==> ', response)

    }).catch(error => {
      console.log('SendMail uri==>error ', error.response)
      setOpen(true);
      if (!error.response) {
        setErrorSnakbar("Network Error")
      }
      else if (error.response.status === 422) {
        for (let i = 0; i < error.response.data.errors.length; i++) {
          setErrorSnakbar(error.response.data.errors[i].msg)
        }
      }
      else {
        setErrorSnakbar(error.response.data.errors)
      }
    })
  }
  const resend = () => {
    sendcode()
    setCount(0)
    setVariable("00:00")
  }
  useInterval(() => {
    // Your custom logic here
    if (count != 60) {
      let variable = count + 1 < 10 ? `00:0${count + 1}` : `00:${count + 1}`
      setCount(count + 1)
      setVariable(variable)

    }
  }, 1000);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false)
  };
  return (
    <div>
      <div style={{ width: "100%", position: "absolute", bottom: "0px" }}>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} message={error} />
      </div>
      <Modal className="forgetmodal text-center" show={show} onHide={props.close} animation={false}>
        <Modal.Header className="justify-content-center pb-0">
          <h3 className="text-white mt-5">{String.forgetpassword}</h3>
          <i style={{ left: lang === "ar" ? "10px" : "", right: lang === "en" ? "10px" : "" }} onClick={props.close} className="fa fa-close closeBTN"></i>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="imgforgetcontainer">
            <img src={forgeticon1} alt="deleteimg" className="forgetimg" />
          </div>
          <h5 style={{ padding: '0px 51px', marginTop: '22px' }}>{String.entercode}</h5>
          <div style={{ padding: "10px", height: '20px' }} className="text-center">
            {/* {count !== 60 && <Timer options={OPTIONS} />} */}
            {count !== 60 &&
              <span style={{ color: "orange", fontSize: "20px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
              >
                {variable}
              </span>
            }

            {count === 60 &&
              <span
                style={{ color: "orange", fontSize: "20px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
                onClick={resend}
              >{String.ResendCode}</span>}
          </div>
          <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '100%', position: 'relative' }}>
            <Row style={{ marginTop: '40px' }}>
              <Col lg='12' style={{ marginBottom: '40px' }}>
                <div className="textWithIcon"  >
                  <PinInput
                    length={5}
                    focus
                    type="numeric"
                    onChange={onChange}
                  />
                  {/* <Col lg="3" md="3">
                    <input type="text" name="num1" ref={register} placeholder='0' className="px-4" style={inputStyle} />
                  </Col>
                  <Col lg="3" md="3">
                    <input type="text" name="num2" ref={register} placeholder='0' className="px-4" style={inputStyle} />
                  </Col>
                  <Col lg="3" md="3">
                    <input type="text" name="num3" ref={register} placeholder='0' className="px-4" style={inputStyle} />
                  </Col>
                  <Col lg="3" md="3">
                    <input type="text" name="num4" ref={register} placeholder='0' className="px-4" style={inputStyle} />
                  </Col> */}
                </div>
                <div className="text-center">
                  {errormsg &&
                    <span style={{ color: "red", fontSize: "12px", height: '10px' }}>{String.confirmCodeError}</span>
                  }
                </div>
                {/* {errors[element.name] && <p className="ErrorStyle">{errors[element.name]["message"]}</p>} */}
              </Col>
            </Row>
            <button className="btn nextBTN btn-block mb-4" type="submit"> {String.next} </button>
          </form>
        </Modal.Body>
      </Modal>
      {openFormNewPass && <NewPassword close={ToggleForm_newPass} phone={data} />}
    </div >
  );
}

export default ConfirmCode;